import React from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";

interface WalletListShimmerProps {
  count?: number;
  showMobileView?: boolean;
}

const WalletListShimmer: React.FC<WalletListShimmerProps> = ({
  count = 10,
  showMobileView = false,
}) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={styles.shimmerItem}>
          {/* Dash line separator */}
          {index > 0 && !showMobileView && <div className={styles.dashLine} />}

          {/* Main container */}
          <div
            className={classNames(styles.container, {
              [styles.mobileShadow]: showMobileView,
              [styles.marginTop]: index === 0,
            })}>
            {/* Right section with icon and line */}
            <div className={styles.rightSection}>
              <div className={styles.icon} />
            </div>

            {/* Left section with content */}
            <div className={styles.leftSection}>
              {/* Title container */}
              <div className={styles.titleContainer}>
                <div className={styles.title} />
                <div className={styles.extra} />
              </div>

              {/* Timeline section */}
              <div className={styles.timelineContainer}>
                <div className={styles.lineContainer} />
                <div className={styles.itemList}>
                  {/* Timeline item */}
                  <div className={styles.timelineItem}>
                    <div className={styles.itemTitle} />
                    <div className={styles.detailsContainer}>
                      <div className={styles.price} />
                      <div className={styles.dataContainer}>
                        <div className={styles.dot} />
                        <div className={styles.time} />
                      </div>
                      <div className={styles.timeContainer}>
                        <div className={styles.clockIcon} />
                        <div className={styles.time} />
                      </div>
                    </div>
                  </div>

                  {/* Status indicator */}
                  <div className={styles.statusIndicator}>
                    <div className={styles.statusText} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default WalletListShimmer;
